<template>
  <v-container id=create-marker-container>
      <v-row>
        <v-col cols=12 sm=6 xs=6 class="right-border">
          <v-divider></v-divider>
          <v-card-title>
            <span class="headline">LOGIN</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="email" label="E-mail" prepend-icon="mdi-email" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="password" :type="'password'" name="input-10-1" prepend-icon="mdi-lock" label="Password" ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="login">Login</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text class='text-capitalize' @click="guestLogin">GUEST LOGIN (viewing only)</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
          
        </v-col>
        
        <v-col cols=12 sm=6 xs=6 class="right-border">
          <v-divider></v-divider>
          <v-card-title>
            <span class="headline">CREATE NEW ACCOUNT</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-col cols="12">
                  <v-text-field v-model="newName" label="Artist Name" prepend-icon="mdi-account-box" required></v-text-field>
                </v-col> -->
                <v-col cols="12">
                  <v-text-field v-model="newEmail" label="E-mail" prepend-icon="mdi-email" required></v-text-field>
                </v-col>
                <!-- <v-col cols="12">
                  <v-text-field v-model="newPassword" :type="'password'" name="input-10-1" prepend-icon="mdi-lock" label="Password" ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="newPasswordVerification" :type="'password'" name="input-10-1" prepend-icon="mdi-lock" label="Repeat Password" ></v-text-field>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="sendEmail">Send Login Link</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-col>

      </v-row>
      <v-alert v-show="errorMessage" dense type="error">{{errorMessage}}</v-alert>
      <v-alert v-show="message" dense type="success">{{message}}</v-alert>
    </v-container>
    
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LoginForm',
  components: {},
  props: {},
  data: () => ({
    email: "",
    password: "",
    newName: "",
    newEmail: "",
    newPassword: "",
    newPasswordVerification: "",
  }),
  computed: mapState({
    errorMessage: 'errorMessage',
    message: 'message',
  }),
  methods: {
    login: async function() {
      this.$store.dispatch("login", {email: this.email, password: this.password});
    },
    guestLogin: async function() {
      this.$store.dispatch("loginGuest");
    },
    async sendEmail() {
      this.$store.dispatch(
        "sendSignUpEmail",
        {email: this.newEmail});
    }
  },
}
</script>

<style scoped>
.right-border {
  border-right: solid;
  border-width: 1px;
  border-color: lightgray;
}
</style>

<style>
#create-marker-container {
  background: black;
}
#create-marker-container *{
  color: red;
  border-color: red;
}

#create-marker-container .red--text {
  background: red;
}
#create-marker-container .red--text *{
  color: black;
}
</style>
